import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Card, Button, Table, Row, Col } from "react-bootstrap";
import ChartsContext from "contexts/ChartsContext";

const CheckinTable = ({ handleCSVDownload, handleTableClose }) => {
  const { updateTime, setUpdateTime } = useContext(ChartsContext);
  const [checkinList, setCheckinList] = useState([]);  // State to store the volunteers data

  const fetchCheckin = () => {
    axios.get(`${process.env.REACT_APP_SERVER_URL}/budhabath/getcheckin`)
      .then(response => {
        setCheckinList(response.data);  
        console.log(response)
        const currentTime = new Date().toLocaleString();
        setUpdateTime(currentTime);
      })
      .catch(error => {
        console.error("Error fetching checkin guests:", error);
      });
  };

  useEffect(() => {
    fetchCheckin();
  }, []);

  return (
    <>
      <Card className="card-stats">
        <Card.Header>
          <Row>
            <Col>
              <Card.Title as="h4">已報到列表</Card.Title>
              <p className="card-category">Checked in Guests Table</p>
            </Col>
            <Col className="text-right">
              <Button variant="info" onClick={() => handleCSVDownload(checkinList, 'checkin_guests')} className='mr-3'>
                Download to CSV
              </Button>
              <Button variant="danger" onClick={handleTableClose}>
                Close Table
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Table className="table-hover table-striped">
            <thead>
              <tr>
                <th>Guest ID</th>
                <th>Name</th>
                <th>Chinese Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Registration Time</th>
                <th>Check-in Time</th>
              </tr>
            </thead>
            <tbody>
              {checkinList.map((volunteer) => (
                <tr key={volunteer.id}>
                  <td>{volunteer.id}</td>
                  <td>{volunteer.firstname} {volunteer.lastname}</td>
                  <td>{volunteer.chinesename || 'N/A'}</td>
                  <td>{volunteer.phone}</td>
                  <td>{volunteer.email}</td>
                  <td>{new Date(volunteer.registrationTime).toLocaleString()}</td>
                  <td>{volunteer.checkedInTime ? new Date(volunteer.checkedInTime).toLocaleString() : 'Not Checked in Yet'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <hr />
          <div className="stats">
            <i className="fas fa-redo mr-1"></i>
            Updated at <span className="font-weight-bold">{updateTime}</span>
          </div>
        </Card.Footer>
      </Card>
    </>
  );
}

export default CheckinTable;
